// Composant de carte statistique mobile réutilisable avec la palette de couleurs de l'application
import React from "react";

interface MobileStatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  color?: "primary" | "success" | "warning" | "danger" | "info";
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}

const MobileStatsCard: React.FC<MobileStatsCardProps> = ({
  title,
  value,
  icon,
  color = "primary",
  trend,
  className = "",
}) => {
  const colorClasses = {
    primary: {
      bg: "bg-primary/10",
      icon: "text-primary",
      border: "border-primary/20",
    },
    success: {
      bg: "bg-meta-3/10",
      icon: "text-meta-3",
      border: "border-meta-3/20",
    },
    warning: {
      bg: "bg-warning/10",
      icon: "text-warning",
      border: "border-warning/20",
    },
    danger: {
      bg: "bg-meta-1/10",
      icon: "text-meta-1",
      border: "border-meta-1/20",
    },
    info: {
      bg: "bg-meta-5/10",
      icon: "text-meta-5",
      border: "border-meta-5/20",
    },
  };

  const selectedColor = colorClasses[color];

  return (
    <div
      className={`
      bg-white rounded-lg p-4 border ${selectedColor.border}
      ${className}
    `}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {trend && (
            <div className="flex items-center mt-1">
              <span
                className={`
                text-xs font-medium
                ${trend.isPositive ? "text-meta-3" : "text-meta-1"}
              `}
              >
                {trend.isPositive ? "+" : ""}
                {trend.value}%
              </span>
            </div>
          )}
        </div>
        <div
          className={`
          w-12 h-12 rounded-lg ${selectedColor.bg} 
          flex items-center justify-center
        `}
        >
          <span className={`w-6 h-6 ${selectedColor.icon}`}>{icon}</span>
        </div>
      </div>
    </div>
  );
};

export default MobileStatsCard;
